<template>
  <div>
    <div class="flex-form-container">
      <div class="form-flex-container">
        <div>Pilot 1</div>
        <HiloSelect
          :options="pilots"
          v-model="form.pilot1Id"
          placeholder="Choose student..."
          theme="grey"
          :customStyle="{
            height: '48px',
            backgroundColor: '#f5f5f5',
            border: 'none',
          }"
        />
      </div>
      <div class="form-flex-container">
        <div>Pilot 2</div>
        <HiloSelect
          :options="pilots"
          v-model="form.pilot2Id"
          placeholder="Choose student..."
          theme="grey"
          :customStyle="{
            height: '48px',
            backgroundColor: '#f5f5f5',
            border: 'none',
          }"
        />
      </div>
      <div class="form-flex-container">
        <div>Instructor</div>
        <HiloSelect
          :options="instructors"
          v-model="form.instructorId"
          placeholder="Choose instructor..."
          theme="grey"
          :customStyle="{
            height: '48px',
            backgroundColor: '#f5f5f5',
            border: 'none',
          }"
        />
      </div>
      <div class="form-flex-container">
        <div>Choose Aircraft</div>
        <HiloSelect
          :options="aircrafts"
          v-model="form.aircraftId"
          placeholder="Choose aircraft..."
          theme="grey"
          :customStyle="{
            height: '48px',
            backgroundColor: '#f5f5f5',
            border: 'none',
          }"
        />
      </div>
      <div class="form-flex-container">
        <div>Departure Time</div>
        <div @click="toggleDatePicker" style="cursor: pointer">
          <input
            type="text"
            placeholder="Choose time..."
            v-model="form.departureTime"
            disabled
            style="pointer-events: none"
          />
        </div>
      </div>
      <div>
        <Draggable
          v-if="form.legs.length"
          :forceFallback="true"
          handle=".drag-handle"
          tag="div"
          class="route-table"
          item-key="id"
          @end="updateLegs"
        >
          <div class="row-header">
            <div>Route</div>
            <div>Start</div>
            <div>End</div>
            <div>Distance</div>
          </div>
          <div v-for="(leg, index) in form.legs" :key="index" class="leg-row">
            <div class="drag-handle leg-item">
              <img src="/static/img/hamburger-menu.svg" alt="" />
              <span>Leg {{ leg?.id }}</span>
            </div>
            <div class="leg-item">
              <HiloSelect
                :options="[]"
                v-model="leg.airportStart"
                placeholder="Airport..."
                theme="grey"
                :customStyle="{
                  height: '48px',
                  backgroundColor: '#f5f5f5',
                  border: 'none',
                }"
              />
            </div>
            <div class="leg-item">
              <HiloSelect
                :options="[]"
                v-model="leg.airportEnd"
                placeholder="Airport..."
                theme="grey"
                :customStyle="{
                  height: '48px',
                  backgroundColor: '#f5f5f5',
                  border: 'none',
                }"
              />
            </div>
            <div class="leg-item relative">
              <input type="text" v-model="leg.distance" />
              <div class="custom-placeholder">nm</div>
            </div>
            <img
              src="/static/img/trash-transparent.svg"
              style="cursor: pointer"
              @click="removeLeg(index)"
              v-if="form.legs.length > 1"
            />
          </div>
        </Draggable>
        <button class="add-btn" @click="addLeg">Add a Leg</button>
      </div>

      <div class="grid-container">
        <div class="row-header flight-info">Flight Information</div>
        <div class="grid" :style="$global.dynamicCols(2)">
          <div class="grid grid-form-control relative">
            <div>Distance</div>
            <input
              type="text"
              placeholder="Distance..."
              v-model="form.distance"
            />
            <div class="custom-placeholder">nm</div>
          </div>
          <div class="grid grid-form-control relative">
            <div>Fuel</div>
            <input type="text" placeholder="Fuel..." v-model="form.fuel" />
            <div class="custom-placeholder">GAL</div>
          </div>
        </div>
        <div class="grid" :style="$global.dynamicCols(2)">
          <div class="grid grid-form-control relative">
            <div>Duration</div>
            <div style="width: 225px" class="d-flex justify-content-between">
              <div
                class="relative"
                :style="'width: ' + (225 / 2 - 5).toString() + 'px'"
              >
                <input
                  type="text"
                  placeholder="0"
                  v-model="form.durationHours"
                />
                <div class="custom-placeholder">Hr</div>
              </div>
              <div
                class="relative"
                :style="'width: ' + (225 / 2 - 5).toString() + 'px'"
              >
                <input
                  type="text"
                  placeholder="0"
                  v-model="form.durationMinutes"
                />
                <div class="custom-placeholder">Min</div>
              </div>
            </div>
          </div>
          <div class="grid grid-form-control">
            <div>Wind</div>
            <input type="text" placeholder="Wind..." v-model="form.wind" />
          </div>
        </div>
        <div class="grid" :style="$global.dynamicCols(2)">
          <div class="grid grid-form-control">
            <div>Arrival</div>
            <input
              type="text"
              placeholder="Arrival Time..."
              v-model="form.arrival"
            />
          </div>
          <div class="grid grid-no-gap grid-form-control relative">
            <div>Mag. Head</div>
            <input
              type="text"
              placeholder="Heading..."
              style="width: 96%; margin-left: 7px"
              v-model="form.magHeading"
            />
            <div class="custom-placeholder">ºM</div>
          </div>
        </div>
      </div>
    </div>

    <DateTimePicker
      :isVisible="showDatePicker"
      @close="toggleDatePicker"
      @getDate="getDate"
    />

    <div>
      <button class="primary" @click="handleNext" :disabled="loading">
        <b-spinner
          v-if="loading"
          label="Loading..."
          variant="light"
          class="spinner-sm"
        >
        </b-spinner>
        Next
      </button>
    </div>
  </div>
</template>

<script>
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import DateTimePicker from "./DateTimePicker.vue";
import AircraftAPIService from "../../servicehandlers/AircraftAPIService.js";
const aircraftAPIService = new AircraftAPIService();
import ActiveStudentsAPIService from "../../servicehandlers/ActiveStudentsAPIService";
const activeStudentsAPIService = new ActiveStudentsAPIService();
import ActiveInstructorsAPIService from "@/servicehandlers/ActiveInstructorsAPIService";
const activeInstructorsAPIService = new ActiveInstructorsAPIService();
import DispatchAPIService from "@/servicehandlers/DispatchAPIService";
const dispatchAPIService = new DispatchAPIService();

export default {
  components: {
    HiloSelect,
    DateTimePicker,
  },
  props: {
    toast: {
      type: Object,
      required: true,
      default: () => {},
    },
    dispatchId: {
      type: Number,
    },
  },
  data() {
    return {
      form: {
        pilot1Id: null,
        pilot2Id: null,
        instructorId: null,
        aircraftId: null,
        legs: [{ airportStart: "", airportEnd: "", distance: "" }],
        durationHours: null,
        durationMinutes: null,
        arrival: null,
        magHeading: null,
      },
      aircrafts: [],
      pilots: [],
      instructors: [],
      showDatePicker: false,
      loading: false,
    };
  },
  watch: {
    form: {
      deep: true,
      handler(newForm) {
        if (!newForm.legs || !Array.isArray(newForm.legs)) {
          this.$set(this.form, "legs", [
            { airportStart: "", airportEnd: "", distance: "" },
          ]);
        }
      },
    },
  },
  async mounted() {
    await this.getPilots();
    await this.getInstructors();
    await this.getAircrafts();
  },
  methods: {
    async handleNext() {
      try {
        this.loading = true;

        const dispatchForm = { disclaimerAgreement: true, ...this.form };
        const flightLegs = this.form.legs;
        delete dispatchForm.legs;
        let body = { dispatch: dispatchForm, legs: flightLegs };
        const dispatch = await dispatchAPIService.create(body);

        this.$emit("next", dispatch);
      } catch (error) {
        this.toast.showError("Unable to proceed");
      } finally {
        this.loading = false;
      }
    },
    async getPilots() {
      try {
        const response = await activeStudentsAPIService.get(this.$router);

        this.pilots = response.map((student) => {
          return {
            name: `${student.user.firstName} ${student.user.lastName}`,
            ...student,
          };
        });
      } catch (error) {
        this.toast.showError("Unable to get pilots");
      }
    },
    async getInstructors() {
      try {
        const response = await activeInstructorsAPIService.get(this.$router);

        this.instructors = response.map((instructor) => {
          return {
            name: `${instructor.user.firstName} ${instructor.user.lastName}`,
            ...instructor,
          };
        });
      } catch (error) {
        this.toast.showError("Unable to get instructors");
      }
    },
    async getAircrafts() {
      try {
        const response = await aircraftAPIService.get(this.$router);

        this.aircrafts = response.map((aircraft) => {
          return { name: aircraft.tailNumber, ...aircraft };
        });
      } catch (error) {
        this.toast.showError("Unable to get aircrafts");
      }
    },

    toggleDatePicker() {
      this.showDatePicker = !this.showDatePicker;
    },
    getDate(val) {
      this.form.departureTime = val;
    },
    addLeg() {
      this.form.legs.push({
        airportStart: "",
        airportEnd: "",
        distance: "",
      });
    },
    updateLegs() {
      this.form.legs = [...this.form.legs];
    },
    removeLeg(index) {
      this.form.legs.splice(index, 1);
    },
  },
};
</script>

<style>
.route-table {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.row-header {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.row-header div,
div.row-header {
  font-weight: bold;
  color: #404040;
}
.row-header div:nth-child(2) {
  margin-left: -5px !important;
}
.row-header div:nth-child(3) {
  margin-left: -10px !important;
}
.row-header div:nth-child(4) {
  margin-left: -18px !important;
}
.leg-row {
  margin-top: -10px;
  background: #fff;
  display: grid;
  padding: 5px 0;
  align-items: center;
  gap: 8px;
  grid-template-columns: 1fr 1fr 1fr 1fr 0.2fr;
  user-select: none;
}
.leg-item {
  width: 160px;
}
.relative {
  position: relative;
}
.custom-placeholder {
  position: absolute;
  right: 10px;
  top: 12px;
  color: #9a9a9a;
}
.relative input {
  padding-right: 35px;
}
.drag-handle {
  cursor: grab;
  display: flex;
  align-items: center;
  gap: 15px;
}
.drag-handle span {
  font-size: 15px;
}
.add-btn {
  font-size: 14px;
  font-weight: normal;
  margin: 15px 0;
  padding: 6px 15px;
}
.grid-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}
.grid {
  display: grid;
  gap: 30px;
}
.grid-no-gap {
  gap: 18px;
  text-align: left;
}
.flight-info {
  margin-bottom: 10px;
  margin: 0;
}
.grid-form-control {
  grid-template-columns: 1fr 3fr;
  align-items: center;
}
</style>
